import { Typography, Card, Box, IconButton, Tooltip } from "@mui/material";
import DetailsCardButton from "./DetailsCardButton";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import VisibilityIcon from "@mui/icons-material/Visibility";
import StarIcon from "@mui/icons-material/Star";
import { useState } from "react";
import ChannelStatusMenu, { getStatusLabel } from "./ChannelStatusMenu";
import { useNavigate } from "react-router-dom";
import { RoutesConfig } from "../router/types";
import { useSelectedItemStore } from "../store/useSelectedItemStore";

interface FavoriteProcessItemProps {
  process: any;
  onRemove: () => void;
  checked: boolean;
}

const FavoriteItemCard: React.FC<FavoriteProcessItemProps> = (
  props: FavoriteProcessItemProps
) => {
  const [isFavorite, setIsFavorite] = useState(true);
  const navigate = useNavigate();
  const setSelectedItemId = useSelectedItemStore((s) => s.setSelectedItemId);

  const handleDetailsClick = () => {
    setSelectedItemId(props.process.CD_PROCESSO);
    navigate(RoutesConfig.DETALHESPROCESSO.path);
  };

  const handleToggleFavorite = () => {
    console.log("processo clicado", props.process);
    if (isFavorite) {
      props.onRemove();
    }
    setIsFavorite(!isFavorite);
  };

  return (
    <Card
      key={props.process.CD_PROCESSO}
      sx={{
        position: "relative",
        display: "flex",
        width: "100%",
        height: "97px",
        borderRadius: "16px",
        backgroundColor: "#F6F6F6",
        boxShadow: "0px 3px 6px #00000029",
        marginBottom: "26px",
        paddingLeft: "16px",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: 0,
          width: "21px",
          height: "100%",
          backgroundColor: "#A5EB17",
          borderRadius: "12px 0px 0px 12px",
        }}
      />
      <Box
        sx={{
          marginLeft: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            Processo
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ID: {props.process.CD_PROCESSO}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          {props.process.NR_DI}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
          <Typography variant="subtitle1" fontWeight="bold" fontSize={"10px"}>
            {props.process.NM_LOC_EMBARQUE}
          </Typography>
          <DetailsCardButton onClick={handleDetailsClick} />
        </Box>
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: "35px",
          right: "10px",
          transform: "translateY(-50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <IconButton
          onClick={props.onRemove}
          sx={{
            width: "24px",
            height: "24px",
            border: "1px solid #0A0C33",
            borderRadius: "4px",
            backgroundColor: props.checked ? "#0A0C33" : "transparent",
            color: props.checked ? "#A5EB17" : "#0A0C33",
            padding: "2px",
            transition: "all 0.3s ease",
          }}
        >
          <StarIcon sx={{ fontSize: "18px" }} />
        </IconButton>
        <Tooltip
          title={`Canal ${getStatusLabel(props.process.CANAL)}`}
          arrow
          style={{ alignItems: "center" }}
          PopperProps={{
            modifiers: [
              { name: "zIndex", enabled: true, options: { zIndex: 9999 } },
            ],
          }}
        >
          <span>
            <ChannelStatusMenu status={props.process.CANAL} isLabel={false} />
          </span>
        </Tooltip>
      </Box>
    </Card>
  );
};

export default FavoriteItemCard;
